import React, { useState, useCallback, useEffect } from "react";

const FilterManager = ({ onFilterChange, filters = {} }) => {
  const [activeFilters, setActiveFilters] = useState(filters);

  // Initialize filters when filters change (e.g., from URL)
  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      setActiveFilters(filters);
    }
  }, [filters]);

  // Handle filter changes from ColumnFilter components
  const handleFilterChange = useCallback(
    (field, filterValues) => {
      setActiveFilters((prev) => {
        const newFilters = { ...prev };

        if (!filterValues || filterValues.length === 0) {
          delete newFilters[field];
        } else {
          newFilters[field] = filterValues;
        }

        return newFilters;
      });

      // Notify parent component with updated filters
      if (onFilterChange) {
        const newFilters = { ...activeFilters };
        if (!filterValues || filterValues.length === 0) {
          delete newFilters[field];
        } else {
          newFilters[field] = filterValues;
        }

        onFilterChange(newFilters);
      }
    },
    [activeFilters, onFilterChange]
  );

  // Clear all filters
  const clearAllFilters = useCallback(() => {
    setActiveFilters({});

    if (onFilterChange) {
      onFilterChange({});
    }
  }, [onFilterChange]);

  // Get filter count
  const getFilterCount = useCallback(() => {
    return Object.keys(activeFilters).length;
  }, [activeFilters]);

  // Check if column has active filter
  const hasActiveFilter = useCallback(
    (field) => {
      return Boolean(activeFilters[field] && activeFilters[field].length > 0);
    },
    [activeFilters]
  );

  // Get filters for a specific column
  const getFilters = useCallback(
    (field) => {
      return activeFilters[field] || [];
    },
    [activeFilters]
  );

  return {
    activeFilters,
    handleFilterChange,
    clearAllFilters,
    getFilterCount,
    hasActiveFilter,
    getFilters,
  };
};

export default FilterManager;
